// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"623a8a7738ce62c9e24b","655":"5b57916b242359af9181"}[chunkId] + ".js";
};